import { atom } from "recoil";

export type FeatureFlags = {
  images_processing: boolean;
}

export const featureFlagsState = atom({
  key: 'featureFlags',
  default: {} as FeatureFlags
});